
import { Injectable } from '@angular/core';

@Injectable({ providedIn:'root' })
export class GraphqlApiService {
  private endpoint=(typeof window!=='undefined' && (window as any).GRAPHQL_API_ENDPOINT)
    ? (window as any).GRAPHQL_API_ENDPOINT
    : 'http://10.211.55.3:5244/graphql';

  private token:string|null=null;
  private refreshFn:(()=>Promise<string|null>)|null=null;
  private authRejectedFn:(()=>void)|null=null;

  setToken(t:string|null){ this.token=t; }
  setTokenRefresh(fn:()=>Promise<string|null>){ this.refreshFn=fn; }
  setAuthRejected(fn:()=>void){ this.authRejectedFn=fn; }

  private headers(){
    const h:any={'Content-Type':'application/json'};
    if(this.token) h['Authorization']=`Bearer ${this.token}`;
    return h;
  }

  async request<T>(query:string, variables?:any):Promise<T>{
    const res = await fetch(this.endpoint,{
      method:'POST',
      headers:this.headers(),
      body:JSON.stringify({query,variables}),
      credentials:'include'
    });

    if(res.status===401 && this.refreshFn){
      const nt = await this.refreshFn();
      if(nt){
        this.token=nt;
        return await this.request<T>(query,variables);
      }
    }

    const json=await res.json();
    if(json.errors){
      // The API refused the token we sent (expired, or signed with a since-rotated key):
      // tell the app, so it drops the dead session instead of failing every call.
      if(this.token && this.authRejectedFn
        && json.errors.some((e:any)=>e?.extensions?.code==='AUTH_NOT_AUTHENTICATED')){
        this.authRejectedFn();
      }
      throw new Error(json.errors.map((e:any)=>e.message).join(','));
    }

    return json.data as T;
  }
}
